import { Component, Input } from '@angular/core';

@Component({
  selector: 'local-seo-color-icon',
  templateUrl: './color-icon.component.html',
  styleUrls: ['./color-icon.component.scss'],
  standalone: false,
})
export class ColorIconComponent {
  @Input() backgroundColor: 'green' | 'dark-green' | 'grey' | 'white' | 'default' = 'default';
  @Input() iconColor: 'green' | 'dark-green' | 'grey' | 'white' = 'white';
  @Input() icon = 'close';
  @Input() text: string;
  @Input() backgroundSize = 18;
  @Input() iconSize = 16;
}
